import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/BrandonHunt.jpg";

const BrandonHBio = (props) => {
  const bioData = {
    title: "Brandon Hunt",
    title2: "Chief Operating Officer",
    hashName: "brandon-hunt",
    bio1: `Brandon Hunt has served as the Chief Operating Officer of our advisor and our sponsor since October 2024, and as a member of the investment committee of our sponsor since October 2024. Mr. Hunt has 17 years of experience in alternative investments, real estate, and digital infrastructure industries with extensive knowledge and experience across capital formation, debt sourcing, and asset management. Mr. Hunt has served as Executive Vice President, Portfolio Manager of our sponsor since April 2019, with various roles in asset management, debt sourcing and structuring, product development, and digital infrastructure market research. Prior to that, Mr. Hunt served as Senior Regional Vice President from December 2015 through March 2019. Prior to rejoining our sponsor, Mr. Hunt served as Regional Sales Director at NexBank Securities from September 2015 to December 2015. Mr. Hunt was originally employed by our sponsor in January 2011, serving in various capital markets and management roles until September 2015.`,
    bio2: `Mr. Hunt started his career in 2007 as an analyst for a commercial real estate acquisitions team where he helped underwrite commercial real estate investments, provided industry research and conducted analysis of public and private real estate companies. Mr. Hunt holds a Bachelor of Arts, Business Administration degree from California State University, Fullerton, graduating Magna Cum Laude from the University Honors Program with a concentration in Finance. His studies included real estate and corporate finance, with a special interest in alternative investments and derivatives. Mr. Hunt was also recipient of the CSUF College of Business and Economics Alumni Scholarship, CSUF Dean’s Advisory Board Scholarship and the TABR Capital Management Scholarship.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      closeBio={props.closeBio}
    />
  );
};

export default BrandonHBio;
